import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

import { LiveArticleSummaryItem } from "./item";

export const Container = styled.div`
  margin-block-start: 23px;

  border: 1px solid #d8d8d8;
  border-width: 1px 0;

  cursor: pointer;
`;

export const StyledLiveArticleSummaryItem = styled(LiveArticleSummaryItem)`
  margin-block-end: 16px;
`;

export const Header = styled.div`
  margin-block: 16px;

  color: #000000;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 18.75px;
  text-align: start;
  text-transform: uppercase;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;
